import { Component, signal, OnInit, OnDestroy, inject, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Header } from './header/header';
import { Sidebar } from './sidebar/sidebar';
import { RouterOutlet } from '@angular/router';
import { LoaderService } from '../services/loader.service';
import { NotificationHubService } from '../services/notification-hub.service';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [CommonModule, Header, Sidebar, RouterOutlet],
  templateUrl: './layout.html',
  styleUrls: ['./layout.scss']
})
export class Layout implements OnInit, OnDestroy {
  sidebarOpen = signal(true);
  sidebarCollapsed = signal(false);
  private loaderService = inject(LoaderService);
  private notificationHubService = inject(NotificationHubService);
  private readonly TABLET_BREAKPOINT = 1024;

  ngOnInit(): void {
    // Force hide any lingering loader from previous pages
    this.loaderService.forceHide();
    
    // Set initial sidebar state based on screen size
    this.checkScreenSize();

    this.notificationHubService.initialize();
  }

  ngOnDestroy(): void {
    this.notificationHubService.shutdown();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    this.checkScreenSize();
  }

  private checkScreenSize(): void {
    const width = window.innerWidth;
    // Set sidebar state based on screen size
    if (width <= this.TABLET_BREAKPOINT) {
      // Tablet and mobile: both false (sidebar hidden/closed)
      this.sidebarOpen.set(false);
      this.sidebarCollapsed.set(false);
    } else {
      // Desktop: open and not collapsed
      this.sidebarOpen.set(true);
      this.sidebarCollapsed.set(false);
    }
  }

  toggleSidebar(): void {
    const width = window.innerWidth;
    if (width <= this.TABLET_BREAKPOINT) {
      // On tablet/mobile, toggle sidebarOpen only
      this.sidebarOpen.update(val => !val);
    } else {
      // On desktop, toggle collapsed state
      this.sidebarCollapsed.update(val => !val);
    }
  }

  onSidebarLinkClicked(): void {
    // When a link is clicked on mobile/tablet, close sidebar
    const width = window.innerWidth;
    if (width <= this.TABLET_BREAKPOINT) {
      this.sidebarOpen.set(false);
    }
  }

  closeSidebar(): void {
    // Close sidebar when backdrop is clicked on mobile/tablet
    const width = window.innerWidth;
    if (width <= this.TABLET_BREAKPOINT) {
      this.sidebarOpen.set(false);
    }
  }
}
